import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaEdit, FaTrash } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer'; 

const API_BASE_URL = 'title-master/';
// 💡 NOTE: We only keep COURSE_API_URL to populate the dropdown inside the modal form
const COURSE_API_URL = 'course-master/'; 

function TitleMaster() {
    const [courses, setCourses] = useState([]); // Used only for Form Dropdown
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    
    // Form States
    const [selectedId, setSelectedId] = useState(null);
    const [courseId, setCourseId] = useState('');
    const [titleDesc, setTitleDesc] = useState('');
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = 10;
    const [mobilePage, setMobilePage] = useState(1);
    
    
    useEffect(() => {

        const delay = setTimeout(() => {

            fetchTitles(
                mobilePage,
                searchQuery
            );

        },400);

        return ()=>clearTimeout(delay);

    },[
    mobilePage,
    searchQuery
    ]);
    useEffect(() => {
        fetchCourses();
        fetchTitles();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await API.get(COURSE_API_URL);
            setCourses(response.data || []); 
        } catch (error) {
            console.error("Error fetching dropdown courses list:", error);
            setCourses([]);
        }
    };

    const handleAddNewClick = (refreshTable) => {
        setIsEditMode(false);
        setCourseId('');
        setTitleDesc('');
        setIsModalOpen(true); // 🟢 Opens modal instantly!
        
        // If refreshTable is available, bind it, otherwise safely check later
        if (refreshTable) {
            window.activeTableRefresh = refreshTable;
        }
    };

    const handleEditClick = (item, refreshTable) => {
        setIsEditMode(true);
        setSelectedId(item.tileid); 
        setCourseId(item.courseid || ''); 
        setTitleDesc(item.titledesc || ''); 
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const payload = {
            courseid: parseInt(courseId, 10),
            titledesc: titleDesc,
            status: 'Active',
            tilecode: 'TC_' + courseId 
        };

        try {
            const token = localStorage.getItem('access_token');
            const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

            if (isEditMode) {
                await API.put(`${API_BASE_URL}${selectedId}/`, payload, { headers });
                toast.success("Updated Successfully!");
            } else {
                await API.post(API_BASE_URL, payload, { headers });
                toast.success("Saved Successfully!");
            }
            setIsModalOpen(false);
            if (window.activeTableRefresh) window.activeTableRefresh();
        } catch (error) {
            console.error("Save Error:", error);
            toast.error("An error occurred while saving.");
        }
    };

    const handleDeleteClick = async (tileid, refreshTable) => {
        if (window.confirm("Are you sure you want to delete this title record permanently?")) {
            try {
                const token = localStorage.getItem('access_token');
                const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
                await API.delete(`${API_BASE_URL}${tileid}/`, { headers });
                toast.error("Title Record Deleted Successfully! 🗑️");
                if (refreshTable) refreshTable();
            } catch (error) {
                toast.error("Failed to delete record.");
            }
        }
    };
    const fetchTitles = async (
    page = 1,
    search = searchQuery
    ) => {

        setLoading(true);

        try {

            const token = localStorage.getItem("access_token");

            const headers = token
                ? { Authorization: `Bearer ${token}` }
                : {};

            const res = await API.get(API_BASE_URL, {
                headers,
                params: {
                    page,
                    search
                }
            });

            if (res.data.results) {

                setList(res.data.results);

                setTotalCount(res.data.count || 0);

            } else {

                setList(res.data);

                setTotalCount(res.data.length || 0);

            }

        } catch (err) {

            console.error(err);

            setList([]);

            setTotalCount(0);

        } finally {

            setLoading(false);

        }

    };
    
    return (
        <div className="p-3 sm:p-5 md:p-8 bg-[#F8FAFC] min-h-screen">
            <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-light text-gray-700 mb-6 md:mb-8">Title Master</h2>
            
            <div className="max-w-6xl mx-auto">
                <div className="flex justify-center md:justify-end mt-4">
                    <button 
                        type="button"
                        onClick={() => handleAddNewClick(window.activeTableRefresh || null)} 
                        className="w-full md:w-auto bg-blue-950 text-white text-xs font-bold px-5 py-2 rounded uppercase border-none cursor-pointer hover:bg-blue-900 shadow-sm transform active:scale-95 transition-transform"
                    >
                        + Add New Title
                    </button>
                </div>
                <div className="hidden md:block">
                <TableContainer
                    columns={['COURSE DESCRIPTION', 'TITLE NAME', 'ACTION']}
                    apiUrl="title-master/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    searchPlaceholder="Search titles globally across all pages..."
                    renderRow={(item, index, srNo, formatCurrency, refreshTable) => (
                        <tr key={item.tileid || index} className="border-b hover:bg-gray-50 transition-colors h-[40px] text-gray-700 text-xs font-medium bg-white">
                            <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[8%] text-center">{srNo}</td>
                            
                            {/* 🟢 ADVANCED: Directly using item.course_name from your backend response! */}
                            <td className="p-3 border-r text-left pl-5 uppercase font-semibold text-slate-800">
                                {item.course_name || `ID: ${item.courseid}`}
                            </td>
                            
                            <td className="p-3 border-r text-left pl-5 uppercase font-medium">{item.titledesc}</td>
                            
                            <td className="w-[12%] p-0 border-r">
                                <div className="flex items-center justify-center w-full h-[40px]">
                                    <div className="flex-1 flex justify-center items-center h-full border-r border-gray-200">
                                        <button type="button" onClick={() => handleEditClick(item, refreshTable)} className="text-[#5c9314] hover:text-green-800 transition-all flex items-center justify-center w-full h-full bg-transparent border-none cursor-pointer">
                                            <FaEdit size={18} />
                                        </button>
                                    </div>
                                    <div className="flex-1 flex justify-center items-center h-full">
                                        <button type="button" onClick={() => handleDeleteClick(item.tileid, refreshTable)} className="text-gray-400 hover:text-red-600 transition-all flex items-center justify-center w-full h-full bg-transparent border-none cursor-pointer">
                                            <FaTrash size={16} />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr> 
                    )}
                />
                </div>
                <div className="md:hidden space-y-4 mt-4">

                <div className="mb-4">

                <input
                type="text"
                value={searchQuery}
                placeholder="Search Title..."
                onChange={(e)=>{

                setSearchQuery(e.target.value);

                setMobilePage(1);

                }}
                className="w-full border rounded-lg p-3 text-sm outline-none"
                />

                </div>

                {

             loading ? (

                    <div className="text-center py-10">
                        Loading...
                    </div>

                ) : list.length === 0 ? (

                    <div className="text-center py-10 text-gray-500">
                        No Record Found
                    </div>

                ) : (

                    list.map((item) => (

                        <div
                            key={item.tileid}
                            className="bg-white rounded-xl shadow border p-4"
                        >

                            <div className="space-y-3">

                                <div>
                                    <p className="text-xs text-gray-500">
                                        Course
                                    </p>

                                    <p className="font-bold text-[#032167]">
                                        {item.course_name}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-gray-500">
                                        Title
                                    </p>

                                    <p className="font-semibold">
                                        {item.titledesc}
                                    </p>
                                </div>

                                <div className="flex justify-end gap-4 pt-3 border-t">

                                    <button
                                        onClick={() => handleEditClick(item, window.activeTableRefresh)}
                                        className="text-green-600"
                                    >
                                        <FaEdit />
                                    </button>

                                    <button
                                        onClick={() => handleDeleteClick(item.tileid, window.activeTableRefresh)}
                                        className="text-red-600"
                                    >
                                        <FaTrash />
                                    </button>

                                </div>

                            </div>

                        </div>

                    ))

                )}

                </div>
                
                
            </div>
            <div className="md:hidden flex justify-between items-center mt-5">

            <button
            disabled={mobilePage===1}
            onClick={()=>setMobilePage(p=>p-1)}
            className="px-4 py-2 border rounded disabled:opacity-40"
            >

            Previous

            </button>

            <span className="text-sm font-semibold">

            Page {mobilePage} of {Math.max(1, Math.ceil(totalCount / pageSize))}

            </span>

            <button
            disabled={mobilePage>=Math.ceil(totalCount/pageSize)}
            onClick={()=>setMobilePage(p=>p+1)}
            className="px-4 py-2 border rounded disabled:opacity-40"
            >

            Next

            </button>

            </div>

            {/* Modal Form */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 bg-black/50 overflow-y-auto">
                    <div className="min-h-full flex items-center justify-center p-3 md:p-6">
                    <div className="bg-white w-full max-w-[95vw] sm:max-w-lg p-5 sm:p-8 rounded-xl relative shadow-2xl border border-gray-100 animate-in zoom-in-95 duration-200">
                        <button type="button" onClick={() => setIsModalOpen(false)} className="absolute right-4 top-2 text-2xl text-gray-400 hover:text-black border-none bg-transparent cursor-pointer">&times;</button>
                        <h3 className="text-sm font-bold uppercase border-b pb-4 mb-6 text-gray-800 tracking-wider">Add/Edit Title Details</h3>
                        <form onSubmit={handleSave} className="space-y-4">
                            <select value={courseId} onChange={(e) => setCourseId(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-xs font-semibold bg-gray-50 outline-none cursor-pointer text-slate-700" required>
                                <option value="">-- Select Course --</option>
                                {courses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                            </select>
                            <input type="text" value={titleDesc} onChange={(e) => setTitleDesc(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-xs bg-gray-50 outline-none font-medium" placeholder="Enter Title Name" required />
                            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 mt-6 pt-4 border-t">
                                <button type="button" onClick={() => setIsModalOpen(false)} className="w-full sm:w-auto px-5 py-2 border rounded-lg text-xs font-semibold bg-white hover:bg-gray-50 cursor-pointer">Cancel</button>
                                <button type="submit" className="w-full sm:w-auto bg-[#032167] text-white px-6 py-2 rounded-lg text-xs font-bold shadow-sm uppercase tracking-wider cursor-pointer border-none hover:bg-blue-950">SAVE</button>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TitleMaster;